import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { MemberNewHireWelcomePage } from './member-new-hire-landing';
import { MemberEmployeeRecord } from './member-employee-record';
import { TcsmAppConfigs } from '../../../../../global/models/configuration-models';
import { useNewHireSettings } from '../../new-hire/hooks/useNewHireSettings';
import { NewHireEnrollmentRoutes } from '../models/new-hire-routes';
import { useMemberGHLEmploymentId } from './hooks/useMemberGHLEmploymentId';
import { NewHireEnrollmentConfirmation } from '../confirmation/new-hire-confirmation';
import { MemberBenefitEnrollment } from './benefit-enrollment/member-benefit-enrollment';
import { clearNewHireEnrollmentState } from '../slice/new-hire-enrollment-slices';
import { MemberNewHireStepper } from './member-new-hire-stepper';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { NewHireEnrollmentStep } from '../models/new-hire-enrollment-models';
import { clearEmploymentCompensation } from '../../employment-compensation/employment-compensation-slices';

interface Props {
	appSettings: TcsmAppConfigs;
}

function MemberNewHireApp(props: Props) {

	const { appSettings } = props;
	const settingsLoaded = useNewHireSettings(appSettings?.newHireSettingsId);
	const routeMatch = useRouteMatch();
	const employmentIdLoaded = useMemberGHLEmploymentId();
	const dispatch = useDispatch();
	const currentStep = useSelector<TcsmStates, NewHireEnrollmentStep>(state => state?.newHireEnrollmentState?.currentStep);
	const location = useLocation();

	const hideStepper = location?.pathname?.includes(NewHireEnrollmentRoutes.Confirmation) ||
						(location?.pathname === routeMatch.path);

	useEffect(() => {
		return function cleanUp() {
			dispatch(clearNewHireEnrollmentState());
			dispatch(clearEmploymentCompensation());
		};
	}, []);


	if (!settingsLoaded && !employmentIdLoaded) {
		return <LoadingCircle />;
	}

	return (
		<>
			<MemberNewHireStepper hideSteps={!currentStep} basePath={routeMatch.path} hideAll={hideStepper} />
			<Switch>
				<Route exact path={routeMatch.path} render={() => <MemberNewHireWelcomePage basePath={routeMatch.path} appSettings={appSettings} />} />
				<Route path={`${routeMatch.path}${NewHireEnrollmentRoutes.EmployeeRecord}`} render={() => <MemberEmployeeRecord settings={appSettings} />} />
				<Route path={`${routeMatch.path}${NewHireEnrollmentRoutes.BenefitEnrollment}`} render={() => <MemberBenefitEnrollment settings={appSettings} />} />
				<Route path={`${routeMatch.path}${NewHireEnrollmentRoutes.Confirmation}`} render={() => <NewHireEnrollmentConfirmation settignsId={appSettings?.newHireSettingsId} />} />													
			</Switch>
		</>
	);
}

export default MemberNewHireApp;

